import React from 'react';
import { Plus, Eye, Edit, Trash2 } from 'lucide-react';

interface PermissionsSummaryProps {
  stats: {
    create: number;
    read: number;
    update: number;
    delete: number;
  };
  totalModules: number;
}

const PermissionsSummary: React.FC<PermissionsSummaryProps> = ({ stats, totalModules }) => {
  const calculatePercentage = (count: number) => {
    return totalModules > 0 ? Math.round((count / totalModules) * 100) : 0;
  };

  return (
    <div className="permissions-summary">
      <div className="summary-card create-card">
        <div className="summary-icon create-icon">
          <Plus size={20} />
        </div>
        <div className="summary-content">
          <div className="summary-label">Create</div>
          <div className="summary-count">{stats.create}</div>
          <div className="summary-percentage">{calculatePercentage(stats.create)}%</div>
          <div className="summary-total">of {totalModules}</div>
        </div>
      </div>
      
      <div className="summary-card read-card">
        <div className="summary-icon read-icon">
          <Eye size={20} />
        </div>
        <div className="summary-content">
          <div className="summary-label">Read</div>
          <div className="summary-count">{stats.read}</div>
          <div className="summary-percentage">{calculatePercentage(stats.read)}%</div>
          <div className="summary-total">of {totalModules}</div>
        </div>
      </div>
      
      <div className="summary-card update-card">
        <div className="summary-icon update-icon">
          <Edit size={20} />
        </div>
        <div className="summary-content">
          <div className="summary-label">Update</div>
          <div className="summary-count">{stats.update}</div>
          <div className="summary-percentage">{calculatePercentage(stats.update)}%</div>
          <div className="summary-total">of {totalModules}</div>
        </div>
      </div>
      
      <div className="summary-card delete-card">
        <div className="summary-icon delete-icon">
          <Trash2 size={20} />
        </div>
        <div className="summary-content">
          <div className="summary-label">Delete</div>
          <div className="summary-count">{stats.delete}</div>
          <div className="summary-percentage">{calculatePercentage(stats.delete)}%</div>
          <div className="summary-total">of {totalModules}</div>
        </div>
      </div>
    </div>
  );
};

export default PermissionsSummary;